<template>
  <div class="shop-create">
    <MainBackButton />

    <div class="wrapper">
      <p class="header">
        Create your Shop
        <span class="is-pulled-right">
          <span v-if="!shopType">1</span>
          <span v-else>2</span>
          / 2</span
        >
      </p>

      <div class="is-flex" style="margin: 16px 0">
        <div class="column" @click="resetForm">
          <progress class="progress is-small is-success" value="1" />
        </div>
        <div class="column">
          <progress
            v-if="!shopType"
            class="progress is-small is-white"
            value="0"
          />
          <progress v-else class="progress is-small is-success" value="1" />
        </div>
      </div>

      <div v-if="!shopType">
        <p class="question">What kind of shop is it?</p>

        <div class="notification" @click="shopType = 'restaurant'">
          Restaurant or F&B
          <i
            class="fa fa-chevron-right is-pulled-right"
            style="padding: 3px 0"
          />
        </div>

        <div class="notification" @click="shopType = 'online'">
          Online, Digital or Social Shop
          <i
            class="fa fa-chevron-right is-pulled-right"
            style="padding: 3px 0"
          />
        </div>

        <div class="notification" @click="shopType = 'grocery'">
          Grocery or Convenience Store
          <i
            class="fa fa-chevron-right is-pulled-right"
            style="padding: 3px 0"
          />
        </div>

        <div class="notification" @click="shopType = 'other'">
          Other Brick & Mortar Store
          <i
            class="fa fa-chevron-right is-pulled-right"
            style="padding: 3px 0"
          />
        </div>

        <div class="notification" @click="shopType = 'service'">
          Service (Cleaning, Laundry, etc)
          <i
            class="fa fa-chevron-right is-pulled-right"
            style="padding: 3px 0"
          />
        </div>
      </div>

      <div v-else>
        <p class="question">
          Where is the shop?
          <!-- <span v-if="country" class="is-pulled-right">
            <flag :iso="country" :squared="false" />
            <i class="fa fa-angle-down" style="font-size: 0.7em; color: grey" />
          </span> -->
        </p>
        <p class="city-country" @click="country = null">
          <span v-if="country">
            <flag :iso="country" :squared="false" />
            <span class="link">Chiang Mai, Thailand</span>
            <i
              class="fa fa-angle-down"
              style="font-size: 0.8em; color: grey; margin-left: 9px"
            />
          </span>
        </p>

        <div v-if="!country">
          <div class="notification" @click="setCountry('th')">
            <flag iso="th" :squared="false" />
            Thailand
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
          <div class="notification" @click="setCountry('sg')">
            <flag iso="sg" :squared="false" />
            Singapore
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
          <div class="notification" @click="setCountry('jp')">
            <flag iso="jp" :squared="false" />
            Japan
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
          <div class="notification" @click="setCountry('id')">
            <flag iso="id" :squared="false" />
            Indonesia
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
          <div class="notification" @click="setCountry('pt')">
            <flag iso="pt" :squared="false" />
            Portugal
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
          <div class="notification" @click="setCountry('th')">
            <flag iso="zz" :squared="false" />
            Other
            <i
              class="fa fa-chevron-right is-pulled-right"
              style="padding: 3px 0"
            />
          </div>
        </div>
        <div v-else>
          <!-- :coords="coords" -->
          <ShopCreateMap :country="country" :city="city" @submit="setAddress" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import MainBackButton from "@/components/MainBackButton";
import ShopCreateMap from "@/components/ShopCreateMap";

export default {
  name: "ShopCreate",
  components: {
    MainBackButton,
    ShopCreateMap,
  },
  data() {
    return {
      location: null,
      country: null,
      city: null,
      shopType: null,
      loginCallback: "SHOP_CREATE_CALLBACK",
    };
  },
  mounted() {
    this.checkLangQuery();
    this.checkFCMQuery();
    this.biasLocation();
    EventBus.$on(this.loginCallback, () => this.createShop());
    var query = this.$route.query;
    if (query.type) this.shopType = query.type;
  },
  beforeDestroy() {
    EventBus.$off(this.loginCallback);
  },
  methods: {
    biasLocation() {
      if (this.$store.state.ipAddress) {
        // this.country = this.$store.state.ipAddress.country;
        this.country = "th";
        this.city = "Chiang Mai";
      }
      // or could use URL param: r=cm if IP address unknown
    },
    resetForm() {
      this.country = null;
      this.shopType = null;
    },
    setCountry(country) {
      this.country = country;
    },
    setAddress(data) {
      this.location = data; // new way
      // check login
      var msg = "Almost there!";
      if (!this.smsLoginOkay(msg, this.loginCallback)) return;
      this.createShop(); // go here if already logged in
    },
    createShop() {
      console.log("createShop", this.location);
      // create new business, then go to commerce_home
      var data = {
        shop_type: this.shopType,
        country: this.country, // could also have city
        address: this.location.address, // also location.name << street name?
        lat: this.location.lat,
        lon: this.location.lon,
        user_id: this.$store.state.user.id,
        is_superuser: this.$store.getters.isSuperUser ? true : false,
      };
      var green = this.bulmaColor("success");
      var loader = this.loadingDots(green);
      this.$store
        .dispatch("createNewShop", data)
        .then((res) => {
          // either return roles with response or update roles
          this.updateRoles(false);
          var msg = `Your new shop is ready!<br>Sending you there now...`;
          this.successToast(msg, "top", 2000);
          var newHome = `/commerce_home/${res.data.id}`;
          setTimeout(() => this.goto(newHome), 2000);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.shop-create {
  overflow: hidden;
}
.wrapper {
  /* position: absolute; */
  text-align: left;
  padding: 16px 12px;
  top: 0;
  height: 100vh;
  padding-bottom: 40px;
  overflow: hidden;
}
.header {
  font-weight: 500;
  font-size: 1.2em;
  color: grey;
  margin-left: 45px;
  padding-bottom: 8px;
}
.state-bars .column {
  text-align: center;
  padding: 12px;
  margin-top: 10px;
  /* margin-bottom: 10px; */
}
.question {
  margin-left: 10px;
  /* text-align: center; */
  font-size: 1.6em;
  font-weight: 550;
  margin-bottom: 20px;
}
.city-country {
  margin: 10px;
  margin-top: -10px;
  font-size: 1.3em;
  /* border: 1px solid #777;
  background-color: white;
  padding: 10px; */
}
.notification {
  padding: 20px;
  font-size: 1.1em;
  border: 1px solid #777;
  background-color: white;
}
.flag {
  -webkit-filter: drop-shadow(2px 2px 2px #666);
  filter: drop-shadow(2px 2px 2px #666);
}
.flag-icon {
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
  font-size: 1.3em;
  border-radius: 2px;
  /* margin-bottom: 10px; */
  margin-right: 10px;
}

/* ---------------- */

.shop-create {
  /* background-color: ivory; */
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  position: absolute;
  height: 150px;
  width: 150px;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.top {
  width: 100vw;
  text-align: left;
}
.top img {
  display: inline-block;
  height: 100px;
  /* margin-right: 10px; */
  margin-top: -10px;
  margin-left: 4px;
}
.top span {
  font-size: 28pt;
  font-weight: 550;
  color: #fac002;
  margin-top: 18px;
  margin-left: -10px;
  position: absolute;
}
.one-liner {
  padding: 20px;
  padding-top: 60px;
  font-size: 36px;
  font-weight: 900 !important;
}
.one-liner i {
  text-shadow: 1px 1px 2px black;
  /* text-shadow: 0 0 1px black; */
  /* text-transform: uppercase; */
}
.subtitle {
  /* margin-top: 20px; */
  padding: 12px;
  margin-bottom: 20px;
}
.btn-wrapper {
  padding: 16px;
  /* background-color: #fac002; */
}
.btn-wrapper .button {
  margin-top: 10px;
  background-color: #fac002;
  font-weight: 600;
  box-shadow: 3px 3px 9px grey;
}
.free {
  font-size: 40pt;
  font-weight: 900;
}
</style>